import HomeRoundedIcon from '@material-ui/icons/HomeRounded';
import React, { useContext } from 'react';
import styled, { css, ThemeContext } from 'styled-components';
import {
  focusRing,
  fontSize,
  fontWeight,
  layout,
  lineHeight,
  media,
  neutral,
  radius,
  space,
  transition,
} from '../../../theme/tokens';

export const ErrorContainer = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${space[5]};
  text-align: center;
  width: 100%;
  min-height: 100%;
  padding: ${space[8]} ${layout.gutter};
  background: ${({ theme }) => theme.staffBackground};

  ${({ fullscreen }) =>
    fullscreen &&
    css`
      min-height: 100vh;
    `};
`;

export const ErrorMessage = styled.h2`
  max-width: ${layout.readableMaxWidth};
  margin: 0;
  font-weight: ${fontWeight.heavy};
  font-size: ${fontSize.xxl};
  line-height: ${lineHeight.tight};
  overflow-wrap: anywhere;
  color: ${({ theme }) => theme.headerColour};

  ${media.md`
    font-size: ${fontSize.display};
  `}
`;

export const BackHomeButton = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${space[1]};
  min-width: ${layout.touchTarget};
  min-height: ${layout.touchTarget};
  padding: ${space[3]} ${space[5]};
  border: none;
  border-radius: ${radius.lg};
  background: none;
  font-family: inherit;
  font-weight: ${fontWeight.bold};
  font-size: ${fontSize.xl};
  text-align: center;
  color: ${({ theme }) => theme.textDark};
  transition: background ${transition.fast};
  &:hover {
    cursor: pointer;
    background: ${neutral.subtle};
  }
  ${focusRing}
`;

export const BigHomeIcon = () => {
  const theme = useContext(ThemeContext);
  return (
    <HomeRoundedIcon style={{ fontSize: '8rem', color: theme.textDark }} />
  );
};
